import React from "react";
import firebaseManager from "../../../model/Firebase/FirebaseManager";

class RequestInfo extends React.Component {
  constructor() {
    super();
    this.dataDent = this.dataDent.bind(this);
    this.state = {
      car_model: "",
      car_brand: "",
      car_year: "",
      dent_place: "",
      info_location: "",
      info_time: "",
      img1: "",
      img2: "",
      img3: "",
      price: "",
    };
    this.dataDent();
  }

  dataDent() {
    firebaseManager.showInfoDent(this.successData, this.failData);
  }

  successData = (data) => {
    this.setState({
      car_model: data.car_model,
      car_brand: data.car_brand,
      car_year: data.car_year,
      dent_place: data.dent_place,
      info_location: data.info_location,
      info_time: data.info_time,
      img1: data.img1,
      img2: data.img2,
      img3: data.img3,
    });
  };

  failData(error) {
    alert(error.message);
  }
  render() {
    return (
      <React.Fragment>
        
          <div className="container mx-auto card-detail mt-3 mb-3">
            <table className="table table-borderless table_color">
              <tbody>
                <tr>
                  <td><b>Make:</b></td>
                  <td>{this.state.car_brand}</td>
                </tr>
                <tr>
                  <td><b>Model:</b></td>
                  <td>{this.state.car_model}</td>
                </tr>
                <tr>
                  <td><b>Year:</b></td>
                  <td>{this.state.car_year}</td>
                </tr>
                <tr>
                  <td><b>Dent:</b></td>
                  <td>{this.state.dent_place}</td>
                </tr>
                <tr>
                  <td><b>Address:</b></td>
                  <td>{this.state.info_location}</td>
                </tr>
                <tr>
                  <td><b>Requested time:</b></td>
                  <td>{this.state.info_time}</td>
                </tr>
              </tbody>
            </table>

            <div className="text-center mt-4 pb-4">
              <div className="row justify-content-between ml-2 mr-2">
                <div className="col-xs-4 mb-1">
                  <img
                    src={this.state.img1}
                    alt="imagen"
                    className="mx-auto sizeImg"
                  />
                </div>
                <div className="col-xs-4 mb-1">
                  <img
                    src={this.state.img2}
                    alt="imagen"
                    className="mx-auto sizeImg"
                  />
                </div>
                <div className="col-xs-4 mb-1">
                  <img
                    src={this.state.img3}
                    alt="imagen"
                    className="mx-auto sizeImg"
                  />
                </div>
              </div>
            </div>
          </div>
      </React.Fragment>
    );
  }
}

export default RequestInfo;
